import React, { useState } from "react";
import { ReactComponent as Magnifier } from "../assets/icons/magnifier.svg";

export default function SearchField({ value, update }) {
  const [isFocused, setIsFocused] = useState(false);
  return (
    <div
      className={`flex items-center h-10 pl-3 rounded-sm bg-active ${
        isFocused || value ? "w-96" : "w-80"
      }`}
    >
      <Magnifier className="fill-[#ccc]" width={26} />
      <input
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        value={value}
        onChange={(e) => update(e.target.value)}
        placeholder="Pesquisar"
        className="border-none focus:outline-0 w-full h-full px-3 text-white bg-transparent"
      />
    </div>
  );
}
